export default "__VITE_ASSET__D_U6XrL7__"